import {requireStudentLogin} from '@/shared/utils/routeGuards';

const StudentCenter = () => import('@/areas/student-center/views/StudentCenterView.vue');

export const studentCenterRoutes = {
   path: '/student',
   component: StudentCenter,
   beforeEnter: requireStudentLogin,
   children: [
      {
         name: 'student-center',
         path: '/student',
         redirect: () => {
            return {path: '/student/home'};
         },
         children: [
            {
               name: 'student-center.index',
               path: '/student/home',
               component: () => import('@/areas/student-center/views/StudentCenterHomeView.vue'),
               meta: {
                  title: 'Today\'s lesson',
               },
            },
            {
               path: '/student/lesson/:assignment_student_id(\\d+)/:assignment_student_resource_id(\\d+)',
               component: () => import('@/areas/student-center/views/StudentCenterLessonView.vue'),
               meta: {
                  title: 'Student lesson',
               },
            },
         ],
      },
   ],
};
